import {useEffect} from '@wordpress/element';
import {useSelect, useDispatch} from '@wordpress/data';
import {create} from '@braintree/fastlane';
import {STORE_KEY} from '@wc-braintree/block-data';

export const useCreateFastlane = ({clientToken, fraudEnabled, dataCollector}) => {

    const fastlane = useSelect(select => {
        return select(STORE_KEY).getFastlane();
    });

    const {
        setFastlane,
    } = useDispatch(STORE_KEY);

    useEffect(() => {
        create({
            authorization: clientToken,
            ...(dataCollector && {
                deviceData: dataCollector.deviceData
            }),
        }).then(result => {
            setFastlane(result);
        });
    }, [fraudEnabled, dataCollector]);

    useEffect(() => {
        setFastlane(fastlane);
    }, []);

    return fastlane;
}